import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, Col, Collapse, Modal, notification, Radio, Row, Tooltip } from "antd";
import { useLocations } from '../CityProvinceManagement/connectApi/location';
import MapWithSingleMarker from '../../components/Map/MapWithSingleMarker';
// import FormatPrice from '../../components/FormatPrice/FormatPricw';
import Num2persian from 'num2persian';
import { useOrders } from './connectApi/createOrder';
// import { Title } from 'ckeditor5';
import ConvertPersianToEnglish from '../../components/ConvertNumberToEnglish';
import { useSubscriptions } from '../Subscriptions/fetchApi';
import { useSearchParams } from 'react-router-dom';
import { baseURL, baseURLWithoutAPI } from "../../baseUrl";
import axios, { all } from 'axios';
import moment from 'jalali-moment'
import Fancyboxx from './PageOne';
import { useNavigate, useLocation } from "react-router-dom";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_fa from "react-date-object/locales/gregorian_fa";
import { useUserActions } from '../Users/connectApi/users';
import Loader from '../../components/Loader/Loder'

export default function UpdateAd() {
    const rejectReason = {
        1044: 'املاک است',
        1045: 'معامله شده',
        1046: 'منصرف شده',
        1047: 'خارج از محدوده است',
        1048: 'سایر',
        1049: 'مشاور املاک هستم.',
        1050: 'معامله شده',
        1051: 'منصرف شدم',
        1052: 'سایر',
        1054: 'همخانه/خوابگاه',
        1055: 'تکراری',
    }

    const registerStatusArray = [
        { id: 23, text: 'تایید شده', color: 'text-green-500' },
        { id: 24, text: 'در انتظار تایید', color: 'text-orange-500' },
        { id: 25, text: 'رد شده', color: 'text-red-500' },
        { id: 26, text: 'در انتظار پرداخت', color: 'text-stone-500' },
        { id: 1043, text: 'ناقص', color: 'text-yellow-500' }
    ];
    moment.locale('fa')

    const { doesRealEstateAgentExists, getDetailsOrders, getAdsCommnetByMasterId, getAdsPicMasterByMasterPriorityId, deleteAdsMaster, editAdsMasterRegisterStatus, getRejectionnReasons, getAdsMasterByPhoneNumber, getDetailMasterByQuery } = useOrders((state) => state.actions);
    const responseFromAdsMasterByPhoneNumber = useOrders((state) => state.responseFromAdsMasterByPhoneNumber);
    const isRealEstateAgent = useOrders((state) => state.isRealEstateAgent)
    const picMaster = useOrders((state) => state.picMaster);
    const cityByParentId = useLocations((state) => state.cityByParentId)
    const { getAllProvinces } = useLocations((state) => state.actions)
    const [searchParams] = useSearchParams()
    const masterId = searchParams.get('id')
    // const [adsMaster, setAdsMaster] = useState({})
    const [registerStatusCode, setRegisterStatusCode] = useState(24)
    const errors = {}
    const [formErrors, setFormErrors] = useState({});




    const [isRejectionModalVisible, setIsRejectionModalVisible] = useState(false)
    const adsRejectReason = useOrders((state) => state.adsRejectReason);
    const [selectedRejectionReason, setSelectedRejectionReason] = useState(0);
    const [isTextAreaVisible, setIsTextAreaVisible] = useState(0);
    const [otherReasonsText, setOtherReasonsText] = useState("");
    const rejectFileHandler = () => {
        getRejectionnReasons("adsRejectReason")
        setIsRejectionModalVisible(true)

    }

    const sendRejection = () => {
        editAdsMasterRegisterStatus(masterId, 25, selectedRejectionReason, otherReasonsText ? otherReasonsText : "")
        setIsRejectionModalVisible(false)
    }

    const inCompleteHandler = () => {
        editAdsMasterRegisterStatus(masterId, 1043, null, null)
    }


    const [mp4Count, setMp4Count] = useState(0);
    const [img1, setImg1] = useState("/icons/Frame79.svg");
    const [img1Binary, setImg1Binary] = useState();
    const [img2, setImg2] = useState(
        // localStorage.getItem("img2")
        //     ? localStorage.getItem("img2")
        //     : "/icons/Frame79.svg"
        "/icons/Frame79.svg"
    );


    const details = useOrders((state) => state.details);


    const [img2Binary, setImg2Binary] = useState();
    const [img3, setImg3] = useState("/icons/Frame79.svg");
    const [img3Binary, setImg3Binary] = useState();
    const [img4, setImg4] = useState("/icons/Frame79.svg");
    const [img4Binary, setImg4Binary] = useState();
    const [img5, setImg5] = useState("/icons/Frame79.svg");
    const [img5Binary, setImg5Binary] = useState();
    const [img6, setImg6] = useState("/icons/Frame79.svg");
    const [img6Binary, setImg6Binary] = useState();
    const [img7, setImg7] = useState("/icons/Frame79.svg");
    const [img7Binary, setImg7Binary] = useState();
    const [img8, setImg8] = useState("/icons/Frame79.svg");
    const [img8Binary, setImg8Binary] = useState();
    const [img9, setImg9] = useState("/icons/Frame79.svg");
    const [img9Binary, setImg9Binary] = useState();
    const [imgList, setImgList] = useState([]);
    const [selectedAreaName, setSelectedAreaName] = useState(['']);
    const [noPhonenumberError, setNoPhonenumberError] = useState(false);
    const [longPhonenumberError, setLongPhonenumberError] = useState(false);
    const [noTitleError, setNoTitleError] = useState(false);
    const [noCoordinatesError, setNoCoordinatesError] = useState(false)
    const [noPrptyTradeTypeCodeError, setNoPrptyTradeTypeCodeError] = useState(false);
    const [noAdsPrptyTypeCodeError, setNoAdsPrptyTypeCodeError] = useState(false);
    // const [noAreaError, setNoAreaError] = useState(false);
    const [noMetrageError, setNoMetrageError] = useState(false);
    const [noPropertyLandMetarageError, setNoPropertyLandMetarageError] = useState(false);
    const [abilityToConvertError, setAbilityToConvertError] = useState(false);
    const [selectedCity, setSelectedCity] = useState(0)
    const [selectedProvince, setSelectedProvince] = useState(0)
    const [areaCenterLatitude, setAreaCenterLatitude] = useState(null)
    const [areaCenterLongitude, setAreaCenterLongitude] = useState(null)
    const [phoneNumbers, setPhoneNumbers] = useState([]); // List of phone numbers
    const [parcelNumber, setParcelNumber] = useState(null)
    const [isAdsDetailVisible, setIsAdsDetailVisible] = useState(false)
    const [buildingOrientation, setBuildingOrientation] = useState("")
    const [floorMaterial, setFloorMaterial] = useState("")
    const [bathroomType, setBathroomType] = useState("")
    const [coolingSystem, setCoolingSystem] = useState("")
    const [heatingSystem, setHeatingSystem] = useState("")
    const [waterHeaterType, setWaterHeaterType] = useState("")
    const [deed, setDeed] = useState("")
    const [unitNumber, setUnitNumber] = useState("")
    const [isRenovated, setIsRenovated] = useState(false)
    const [isProvinceCityLocked, setIsProvinceCityLocked] = useState(false);
    const [lockedLocation, setLockedLocation] = useState({
        provinceId: null,
        cityId: null,
    });
    const [chooseProvinceAndCityError, setChooseProvinceAndCityError] = useState(false)
    const [chooseLockedCategoryTradeTypeError, setChooseLockedCategoryTradeTypeError] = useState(false)
    const [isCategoryTradeTypeLocked, setIsCategoryTradeTypeLocked] = useState(false);
    const [lockedCategoryTradeType, setLockedCategoryTradeType] = useState({
        adsMainCategoryCode: null,
        adsPrptyTradeTypeCode: null,
        adsPrptyTypeCode: null,
    });
    const [searchProvince, setSearchProvince] = useState("");
    const [searchCity, setSearchCity] = useState("");

    const openNotification = () => {
        notification.open({
            icon: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                    />
                </svg>
            ),
            message: "اخطار",
            description: "3 تا ویدئو بیشتر انتخاب نکن",
        });
    };

    function FormatPrice(price) {
        if (!price) return "";
        const priceString = price.toString();
        return priceString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function convertPersianToEnglish(num) {
        const persianMap = {
            "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4",
            "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9",
            "٬": "," // Add Persian comma to English comma mapping
        };
        return num.replace(/[۰-۹٬]/g, (match) => persianMap[match] || match);
    }

    // const handleCityChange = (e) => {
    //     // console.log(e?.target.value, " e e  e e e 22222222");
    //     // setSelectedCity(e?.target.value)
    //     // getLocationByParentId(e?.target.value)
    //     // const city = cityByParentId.find(city => city.id === e?.target.value)
    //     // setAreaCenterLatitude(city?.centerLatitude)
    //     // setAreaCenterLongitude(city?.centerLongitude)
    //     const cityId = e?.target.value;
    //     setSelectedCity(cityId);
    //     const city = cityByParentId.find((city) => city.id === cityId);
    //     if (city) {
    //         setAreaCenterLatitude(city.centerLatitude);
    //         setAreaCenterLongitude(city.centerLongitude);
    //     }
    //     setSelectedAreaId(null); // Reset area when city changes
    //     getLocationByParentId(cityId); // Fetch areas for the selected city
    // }
    // const handleProvinceChange = (e) => {
    //     // console.log(e?.target.value, " e e  e e e 22222222");
    //     // setSelectedProvince(e?.target.value)
    //     // getOneCity(e?.target?.value)
    //     const provinceId = e?.target.value;
    //     setSelectedProvince(provinceId);
    //     const province = provinceByParentId.find((prov) => prov.id === provinceId);
    //     if (province) {
    //         setAreaCenterLatitude(province.centerLatitude);
    //         setAreaCenterLongitude(province.centerLongitude);
    //     }
    //     setSelectedCity(0); // Reset city when province changes
    //     setSelectedAreaId(null); // Reset area when province changes
    //     getOneCity(provinceId); // Assuming this fetches cities for the selected province
    // }


    const [pageChangeLoader, setPageChangeLoader] = useState(false);
    const [nextId, setNextId] = useState(false);
    const [prevId, setPrevId] = useState(false);
    const [someThing, setSomething] = useState(false);
    const navigate = useNavigate();
    const [allAdIDs, setAllAdIDS] = useState([]);
    const allAdsIDs = useOrders((state) => state.allAdsIDs);
    const [flag, setFlag] = useState(false);
    const { state } = useLocation(); // Access the `state` passed from the Link
    const { currentPage } = state || {};
    const [pageNoFilter, setPageNoFilter] = useState(currentPage)
    const [currentIndex, setCurrentIndex] = useState(false);
    const { getAllCountryes } = useLocations((state) => state.actions)
    const userCode = useOrders((state) => state.userCode);
    const { getUserById } = useUserActions((state) => state.actions);


    const handleNextPrev = (adsId, isNext) => {
        console.log("adsId: ", adsId);

        navigate(`/updateAd?id=${adsId}`)

        if (isNext) {
            callGetDetailMasterByQuery(true)
        } else {
            callGetDetailMasterByQuery(false)
        }

        // getAdsFromApi(adsId)
    }

    useEffect(() => {

        console.log("[allAdIDs, masterId] useEffect");
        if (allAdIDs && Array.isArray(allAdIDs) && masterId) {


            const index = allAdIDs.indexOf(Number(masterId));
            setCurrentIndex(index);


            if (index !== -1) {

                console.log("index NOT -1 ");
                console.log("allAdIDs.length: ", allAdIDs.length);
                if (index < allAdIDs.length - 1) {
                    setNextId(allAdIDs[index + 1])
                }

                // setNextId(index < allAdIDs.length - 1 ? allAdIDs[index + 1] : null);
                setPrevId(index > 0 ? allAdIDs[index - 1] : null);


            } else {
                console.log("index -1 ");
                setNextId(null);
                setPrevId(null);
            }
        }
    }, [allAdIDs, masterId]);

    useEffect(() => {

        const storedIDs = localStorage.getItem('allAdsIDs');
        // setAllAdIDS(allAdsIDs)
        if (storedIDs) {
            setAllAdIDS(JSON.parse(storedIDs));
        }
    }, [])

    useEffect(() => {
        console.log("[masterId] useEffect");
        console.log("masterId: ", masterId);
        console.log("userCode: ", userCode);


        // getDetailsOrdersHandler()
        getDetailsOrders(masterId)
        getAdsCommnetByMasterId(masterId)
        getAllCountryes("1")
        if (userCode !== 0) {
            getUserById(userCode)
        }
        getAdsPicMasterByMasterPriorityId(masterId, 0)
    }, [masterId])

    const callGetDetailMasterByQuery = async (isNext) => {
        setPageChangeLoader(true)

        console.log("isNext: ", isNext);


        const storedValues = JSON.parse(localStorage.getItem("adsFilterState"));
        if (storedValues) {
            console.log("storedValues TRUE");

            const {
                selectedAreaIds,
                registerStatusCode,
                addedBy,
                adsPrptyTradeTypeCode,
                adsPrptyTypeCode,
                meterageFrom,
                meterageTo,
                buldingLifeFrom,
                buldingLifeTo,
                parking,
                basement,
                elevator,
                pricesPricePerMeterFrom,
                pricesPricePerMeterTo,
                totalPriceFrom,
                totalPriceTo,
                rentFrom,
                rentTo,
                depositFrom,
                depositTo,
                priceFrom,
                priceTo,
                adsDateTimeFrom,
                adsDateTimeTo,
                adsMainCategoryCode,
                rejectReasonCode,
                searchQuery,
                myCurrentPage,
            } = storedValues;
            const adsAdvertiseTypeCode = 1;
            const safe = !prevId ? (((myCurrentPage - 1) > -1) ? (myCurrentPage - 1) * 20 : 0) : (myCurrentPage + 1) * 20



            await getDetailMasterByQuery(
                /*  page, */!prevId ? (((myCurrentPage - 2) > -1) ? (myCurrentPage - 1) * 20 : 0) : (myCurrentPage + 1) * 20,
                /*  lastId, */0,
                adsMainCategoryCode,
                // 1,
                0,
                /*   adsTypeCode, */
                adsAdvertiseTypeCode,
                [adsPrptyTradeTypeCode],
                [adsPrptyTypeCode],
                null,
                1,
                2,
                3,
                // [0],
                selectedAreaIds,
                priceFrom,
                priceTo,
                depositFrom,
                depositTo,
                rentFrom,
                rentTo,
                meterageFrom,
                meterageTo,
                buldingLifeFrom,
                buldingLifeTo,
                adsDateTimeFrom ? ConvertPersianToEnglish(adsDateTimeFrom.convert(gregorian, gregorian_fa).format("YYYY-MM-DD")) : null,
                adsDateTimeTo ? ConvertPersianToEnglish(adsDateTimeTo.convert(gregorian, gregorian_fa).format("YYYY-MM-DD")) : null,
                parking,
                basement,
                elevator,
                searchQuery,
                /*  isKeepPrevState, isFilter */true,
                addedBy,
                registerStatusCode,
                rejectReasonCode,

            )
            // setAllAdIDS(...allAdIDs, ...allAdsIDs)
            setAllAdIDS([...new Set([...allAdIDs, ...allAdsIDs])]);

            setSomething(isNext)
            setFlag(true)

            const navigateToId = isNext ? allAdsIDs[0] : allAdsIDs[allAdsIDs.length - 1];
            if (navigateToId) {
                navigate(`/updateAd?id=${navigateToId}`);
            }
            // allAdsIDs?.length &&  navigate(`/productDetails/${allAdsIDs[allAdsIDs?.length - 2]}`)

        } else {
            ;

            console.log("storedValues FALSE");

            await getDetailMasterByQuery(
        /*  page, */!prevId ? (((pageNoFilter - 2) > -1) ? (pageNoFilter - 1) * 20 : 0) : (pageNoFilter + 1) * 20,
        /*  lastId, */0,
                adsMainCategoryCode,
                // 1,
                0,
                /*   adsTypeCode, */
                null,
                [adsPrptyTradeTypeCode],
                [adsPrptyTypeCode],
                null,
                1,
                2,
                3,
                // [0],
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                "",
       /*  isKeepPrevState, isFilter */true,
                addedBy,
                null,
                null,

            )
            // setAllAdIDS(...allAdIDs, ...allAdsIDs)
            setAllAdIDS([...new Set([...allAdIDs, ...allAdsIDs])]);

            setSomething(isNext)
            setFlag(true)

            const navigateToId = isNext ? allAdsIDs[0] : allAdsIDs[allAdsIDs.length - 1];
            if (navigateToId) {
                navigate(`/updateAd?id=${navigateToId}`);
            }



        }
        setPageChangeLoader(false)
    }












    // const getAdsFromApi = async (id) => {

    //     await axios.get(`${baseURL}/Advertise/GetAdsMasterDetailByMasterId?masterId=${masterId}`, {
    //         headers: {
    //             "accept": "text/plain",
    //             "Content-Type": "application/json",
    //             Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
    //         },
    //     })
    //         .then((res) => {
    //             console.log("Api Call Result: ", res);

    //             if (res.data) {
    //                 setAdsMaster(res.data[0])
    //                 return res.data[0]
    //             }
    //         }).catch((err) => {
    //             return;
    //         })
    // }


    const handleSetProvince = (provinceId, cityId = 0, areaId = null) => {

        if (isProvinceCityLocked) return; // Prevent change if locked

        setSelectedProvince(provinceId);
        const province = provinceByParentId.find((prov) => prov.id === provinceId);
        if (province) {
            setAreaCenterLatitude(province.centerLatitude);
            setAreaCenterLongitude(province.centerLongitude);
        }

        setSelectedCity(cityId);
        setSelectedAreaId(areaId);
        getOneCity(provinceId);

        handleSelectDistrict(details[0].areaCode)
        setSelectedAreaName(details[0].areaName)

        // Save current province if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                provinceId,
            }));
        }
    };


    const handleSetCity = (cityId, areaId = null) => {

        console.log("handleSetCity AreaId: ", areaId);


        if (isProvinceCityLocked) return; // Prevent change if locked
        setChooseProvinceAndCityError(false)
        setSelectedCity(cityId);
        const city = cityByParentId.find((city) => city.id === cityId);
        if (city) {
            setAreaCenterLatitude(city.centerLatitude);
            setAreaCenterLongitude(city.centerLongitude);
        }

        setSelectedAreaId(areaId);
        getLocationByParentId(cityId);

        // Save current city if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                cityId,
            }));
        }
    };

    const handleProvinceChange = (e) => {
        const provinceId = e?.target.value;

        if (isProvinceCityLocked) return; // Prevent change if locked

        setSelectedProvince(provinceId);
        const province = provinceByParentId.find((prov) => prov.id === provinceId);
        if (province) {
            setAreaCenterLatitude(province.centerLatitude);
            setAreaCenterLongitude(province.centerLongitude);
        }

        setSelectedCity(0);
        setSelectedAreaId(null);
        getOneCity(provinceId);

        // Save current province if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                provinceId,
            }));
        }
    };

    const handleCityChange = (e) => {
        const cityId = e?.target.value;

        if (isProvinceCityLocked) return; // Prevent change if locked
        setChooseProvinceAndCityError(false)
        setSelectedCity(cityId);
        const city = cityByParentId.find((city) => city.id === cityId);
        if (city) {
            setAreaCenterLatitude(city.centerLatitude);
            setAreaCenterLongitude(city.centerLongitude);
        }

        setSelectedAreaId(null);
        getLocationByParentId(cityId);

        // Save current city if lock is active
        if (isProvinceCityLocked) {
            setLockedLocation((prev) => ({
                ...prev,
                cityId,
            }));
        }
    };
    useEffect(() => {




        phoneNumbers[0] && doesRealEstateAgentExists(phoneNumbers[0])

        phoneNumbers[0] && getAdsMasterByPhoneNumber(phoneNumbers[0])
        phoneNumbers[1] && getAdsMasterByPhoneNumber(phoneNumbers[1])
    }, [phoneNumbers])


    useEffect(() => {

        // console.log("adsMaster: ", adsMaster);
        if (details.length > 0 && details[0].id) {
            setAdsTitle(details[0].adsTitle)
            setAddress(details[0].address)
            setBalcony(details[0].balcony)
            setIsRenovated(details[0].isRenovated)
            setFullName(details[0].ownerName)
            setDescription(details[0].description)
            setSelectedProvince(details[0].stateCode);
            setRegisterStatusCode(details[0].registerStatusCode);
            setAdsPrptyTradeTypeCode(details[0].adsPrptyTradeTypeCode)
            setAdsPrptyTypeCode(details[0].adsPrptyTypeCode)
            setAdsMainCategoryCode(details[0].adsMainCategoryCode)
            setIsRenovated(details[0].isRenovated)
            setParcelNumber(details[0].parcelNumber)
            setBuildingOrientation(details[0].buildingOrientation)

            setDeed(details[0].deed)
            setWaterHeaterType(details[0].waterHeaterType)
            setHeatingSystem(details[0].heatingSystem)
            setCoolingSystem(details[0].coolingSystem)
            setBathroomType(details[0].bathroomType)
            setFloorMaterial(details[0].floorMaterial)
            setOfficialDeed(details[0].officialDeed)
            setUnitNumber(details[0].unitNumber)
            setIsApproximateArea(details[0].isApproximateArea)
            if (details[0].latitude != null) {
                setSelectedCoordinates([details[0].latitude, details[0].longitude])
            }

            setPhoneNumbers(
                details[0].tblAdsPhoneNumbers
                    ?.filter(item => item.phoneNumber !== "") // Exclude empty phone numbers
                    .map(item => item.phoneNumber)
            );

            if (details[0].stateCode > 0) {
                handleSetProvince(details[0].stateCode, details[0].cityCode, details[0].areaCode)
            }
            if (details[0].cityCode > 0) {
                // handleSetCity(adsMaster.cityCode, adsMaster.areaCode)
            }
            if (details[0].tblAdsPrptyDetails.length > 0) {

                setParking(details[0].tblAdsPrptyDetails[0].parking)
                setBasement(details[0].tblAdsPrptyDetails[0].basement)
                setElevator(details[0].tblAdsPrptyDetails[0].elevator)
                setTotalPrice(details[0].tblAdsPrptyDetails[0].totalPrice)
                setPricePerMeter(details[0].tblAdsPrptyDetails[0].pricePerMeter)
                setDeposit(details[0].tblAdsPrptyDetails[0].deposit)
                setRent(details[0].tblAdsPrptyDetails[0].rentPerMonth)
                setMetrage(details[0].tblAdsPrptyDetails[0].meterage)
                setLifeOfTheBuilding(details[0].tblAdsPrptyDetails[0].lifeOfTheBuilding)
                setNumberOfRooms(details[0].tblAdsPrptyDetails[0].numberOfRooms)
                setAbilityToConvert(details[0].tblAdsPrptyDetails[0].abilityToConvert)
                setFloorFrom(details[0].tblAdsPrptyDetails[0].floorNumber)
                setFloorTo(details[0].tblAdsPrptyDetails[0].totalFloor)
                setUnitPerFloor(details[0].tblAdsPrptyDetails[0].unitPerFloor)
                setConvertingRentAmount(details[0].tblAdsPrptyDetails[0].convertingRentAmount)
                setConvertingDepositAmount(details[0].tblAdsPrptyDetails[0].convertingDepositAmount)
            }
        }

    }, [details])

    useEffect(() => {
        const savedLockState = localStorage.getItem('isProvinceCityLocked') === 'true';
        const savedLocation = JSON.parse(localStorage.getItem('lockedLocation'));

        // Get ads
        if (masterId > 0) {
            // get ads
            // getAdsFromApi(masterId)
            // get images            
            getAdsPicMasterByMasterPriorityId(masterId, 0)
        }

        setIsProvinceCityLocked(savedLockState);

        if (savedLockState && savedLocation) {
            setLockedLocation(savedLocation);
            // Optionally restore UI state like selectedProvince, selectedCity
            setSelectedProvince(savedLocation.provinceId);
            setSelectedCity(savedLocation.cityId);

            // If needed: fetch city data based on province, center coordinates, etc.
            if (savedLocation.provinceId) getOneCity(savedLocation.provinceId);
            if (savedLocation.cityId) getLocationByParentId(savedLocation.cityId);
        }
    }, []);
    useEffect(() => {
        if (isProvinceCityLocked) {
            const newLockedLocation = {
                provinceId: selectedProvince,
                cityId: selectedCity,
            };
            setLockedLocation(newLockedLocation);
            localStorage.setItem('lockedLocation', JSON.stringify(newLockedLocation));
        }
    }, [selectedProvince, selectedCity, isProvinceCityLocked]);
    const adsPrptyTradeTypeCodes = {
        1: "فروش",
        2: "رهن و اجاره",
        3: "معاوضه",
        4: "مشارکت در ساخت",
        5: "پیش فروش",
        6: "رهن و اجاره کوتاه مدت",
        7: "متقاضی خرید",
        8: "متقاضی اجاره",
    }
    const propertyTypes = {
        1: "آپارتمان مسکونی",
        2: "آپارتمان اداری",
        3: "خانه و ویلا",
        4: "زمین کلنگی",
        5: "مستغلات",
        6: "مغازه",
        7: "صنعتی و کشاورزی",
    };
    const categoryMap = {
        1: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 9, 7: 10, 8: 11 }, // adsPrprtyType: 1
        2: { 1: 1, 2: 2, 3: 1, 4: 8, 5: 1, 6: 1, 7: 10, 8: 11 }, // adsPrprtyType: 2
        3: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        4: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: null, 7: 10, 8: 11 },
        5: { 1: 6, 2: 7, 3: 6, 4: 8, 5: 6, 6: null, 7: 10, 8: 11 },
        6: { 1: 3, 2: 4, 3: 3, 4: 8, 5: 3, 6: null, 7: 10, 8: 11 },
        7: { 1: 5, 2: 12, 3: 5, 4: 8, 5: null, 6: 9, 7: 10, 8: 11 },
        // Add other adsPrprtyType and adsPrprtyTradeType mappings here
    };
    function getAdsPrprtyCategory(adsPrprtyType, adsPrprtyTradeType) {
        return categoryMap[adsPrprtyType]?.[adsPrprtyTradeType] ?? null; // Default to null if not found
    }
    const areas = useLocations((state) => state.areas)
    const { getLocationByParentId } = useLocations((state) => state.actions)
    const { getUserInit } = useSubscriptions((state) => state.actions)
    const userInit = useSubscriptions((state) => state.userInit)
    const { addOrder, addOrderDetails, saveOrderImg, addsPrptyAuction, postEditAdsDetail, addPhoneNumbers, addPropertyApplicantRentBuy } = useOrders((state) => state.actions)
    const masterCode = useOrders((state) => state.masterCode)
    const collapseRef = useRef(null);
    const [activeKey, setActiveKey] = useState(['']);
    const [selectedAreaId, setSelectedAreaId] = useState(null);
    const [selectedCityId, setSelectedCityId] = useState(null);
    const [selectedProvinceId, setSelectedProvinceId] = useState(null);
    const [areaList, setAreaList] = useState(areas)
    const [adsMainCategoryCode, setAdsMainCategoryCode] = useState(1)
    const [addedBy, setAddedBy] = useState(null)
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedCoordinates, setSelectedCoordinates] = useState([]);
    const [adsTitle, setAdsTitle] = useState("");
    const [newPhoneNumber, setNewPhoneNumber] = useState(""); // For adding/editing 

    const [editIndex, setEditIndex] = useState(null); // Track which number is being edited
    const [adsPrptyTradeTypeCode, setAdsPrptyTradeTypeCode] = useState(null)
    const [adsPrptyTypeCode, setAdsPrptyTypeCode] = useState(null)
    const [adsPrptyCategoryCode, setAdsPrptyCategoryCode] = useState(null)
    const [pricePerMeter, setPricePerMeter] = useState(null)
    const [totalPrice, setTotalPrice] = useState(null)
    const [metrage, setMetrage] = useState(null)
    const [numberOfRooms, setNumberOfRooms] = useState(null)
    const [lifeOfTheBuilding, setLifeOfTheBuilding] = useState(null)
    const [floorTo, setFloorTo] = useState(null)
    const [floorFrom, setFloorFrom] = useState(null)
    const [unitPerFloor, setUnitPerFloor] = useState(null)
    const [parking, setParking] = useState(false)
    const [basement, setBasement] = useState(false)
    const [elevator, setElevator] = useState(false)
    const [isApproximateArea, setIsApproximateArea] = useState(null);
    const [deposit, setDeposit] = useState(null);
    const [rent, setRent] = useState(null);
    const [convertingDepositAmount, setConvertingDepositAmount] = useState(null);
    const [convertingRentAmount, setConvertingRentAmount] = useState(null);
    const [abilityToConvert, setAbilityToConvert] = useState(false)
    const [propertyLandMetarage, setPropertyLandMetarage] = useState(null)
    const [squareFootageEntireProperty, setSquareFootageEntireProperty] = useState(null)
    const [propertyWidth, setPropertyWidth] = useState(null)
    const [buyPriceFrom, setBuyPriceFrom] = useState(null)
    const [buyPriceTo, setBuyPriceTo] = useState(null)
    const [metrageFrom, setMetrageFrom] = useState(null)
    const [meterageTo, setMeterageTo] = useState(null)
    const [lifeOfBuildingFrom, setLifeOfTheBuildingFrom] = useState(null)
    const [lifeOfBulidingTo, setLifeOfTheBuildingTo] = useState(null)
    const [rentPriceFrom, setRentPriceFrom] = useState(null)
    const [rentPriceTo, setRentPriceTo] = useState(null)
    const [rentDepositFrom, setRentDepositFrom] = useState(null)
    const [rentDepositTo, setRentDepositTo] = useState(null)
    const [address, setAddress] = useState(null)
    const [fullName, setFullName] = useState(null)
    const [description, setDescription] = useState(null)
    const [balcony, setBalcony] = useState(false)
    const [officialDeed, setOfficialDeed] = useState(false)
    const { getOneCity, getOneProvince } = useLocations((state) => state.actions)
    const provinceByParentId = useLocations((state) => state.provinceByParentId)


    useEffect(() => {
        if (areas.length) {
            setAreaList(areas)
        }
        // else {
        //     getLocationByParentId(3)
        // }

    }, [areas]);

    useEffect(() => {

        getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode)
        setAdsPrptyCategoryCode(getAdsPrprtyCategory(adsPrptyTypeCode, adsPrptyTradeTypeCode))
        // setAbilityToConvert(false)
    }, [adsPrptyTypeCode, adsPrptyTradeTypeCode])

    useEffect(() => {
        getUserInit(localStorage.getItem("pelakUserId"))
        getOneProvince(1)

        const isLocked = localStorage.getItem('isCategoryTradeTypeLocked') === 'true';
        const savedData = JSON.parse(localStorage.getItem('lockedCategoryTradeType'));

        setIsCategoryTradeTypeLocked(isLocked);

        if (isLocked && savedData) {
            setLockedCategoryTradeType(savedData);
            setAdsMainCategoryCode(savedData.adsMainCategoryCode);
            setAdsPrptyTradeTypeCode(savedData.adsPrptyTradeTypeCode);
            setAdsPrptyTypeCode(savedData.adsPrptyTypeCode);
        }
    }, [])
    useEffect(() => {
        if (userInit) {
            if (!provinceByParentId?.length) {


                getOneProvince(1)
            }
            // getOneCity(userInit?.state)



            // getOneCity(2)
            // const z = provinceByParentId?.find((pro) => pro?.id === userInit?.state)

            // setAreaCenterLatitude(z?.centerLatitude)
            // setAreaCenterLongitude(z?.centerLongitude)
            if (areas.length) {
                setAreaList(areas)
            } else {
                getLocationByParentId(userInit?.city)
            }
        }
    }, [userInit])

    // console.log({ cityByParentId });


    useEffect(() => {
        const z = provinceByParentId?.find((pro) => pro?.id === userInit?.state)
        setAreaCenterLatitude(z?.centerLatitude)
        setAreaCenterLongitude(z?.centerLongitude)
    }, [provinceByParentId])
    useEffect(() => {
        if (isCategoryTradeTypeLocked) {
            const newData = {
                adsMainCategoryCode,
                adsPrptyTradeTypeCode,
                adsPrptyTypeCode,
            };
            setLockedCategoryTradeType(newData);
            localStorage.setItem('lockedCategoryTradeType', JSON.stringify(newData));
        }
    }, [adsMainCategoryCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, isCategoryTradeTypeLocked]);

    // const provincesCollapse = [
    //     {
    //         key: '23',
    //         label: `استان ${selectedProvince !== 0 && provinceByParentId.find(c => c.id === selectedProvince)?.locName ?
    //             `/${provinceByParentId.find(c => c.id === selectedProvince)?.locName}` : ''}`,
    //         children: (
    //             <div className="flex flex-col space-y-4">
    //                 <Radio.Group

    //                     onChange={handleProvinceChange}
    //                     className="flex flex-col"
    //                 >
    //                     {provinceByParentId.map((province) => (
    //                         <Radio key={province.id} value={province.id}>
    //                             {province.locName}
    //                         </Radio>
    //                     ))}
    //                 </Radio.Group>
    //             </div>),
    //         disabled: isProvinceCityLocked,
    //     }
    // ]
    const filteredProvinces = provinceByParentId.filter((province) =>
        province.locName.includes(searchProvince)
    );
    const filteredCities = cityByParentId.filter((city) =>
        city.locName.includes(searchCity)
    );
    const provincesCollapse = [
        {
            key: '23',
            label: `* استان ${selectedProvince !== 0 && provinceByParentId.find(c => c.id === selectedProvince)?.locName ?
                `/${provinceByParentId.find(c => c.id === selectedProvince)?.locName}` : ''}`,
            children: (
                <div className="flex flex-col space-y-4">
                    {/* Search input */}
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        className="flex items-center bg-gray-100 p-2 rounded"
                    >
                        <input
                            type="text"
                            value={searchProvince}
                            onChange={(e) => setSearchProvince(e.target.value)}
                            placeholder="جست‌وجوی استان"
                            className="w-full bg-transparent outline-none border-none"
                        />
                        <button type="submit">
                            <img src="/icons/search.svg" alt="جست و جو" />
                        </button>
                    </form>

                    {/* Filtered list of provinces */}
                    <Radio.Group onChange={handleProvinceChange} className="flex flex-col">
                        {filteredProvinces.map((province) => (
                            <Radio key={province.id} value={province.id}>
                                {province.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
            ),
            disabled: isProvinceCityLocked,
        }
    ];
    // const citiesCollapse = [
    //     {
    //         key: '22',
    //         label: `شهر ${selectedCity !== 0 && cityByParentId.find(c => c.id === selectedCity)?.locName ?
    //             `/${cityByParentId.find(c => c.id === selectedCity)?.locName}` : ''}`,
    //         children: (
    //             <div className="flex flex-col space-y-4">
    //                 <Radio.Group

    //                     onChange={handleCityChange}
    //                     className="flex flex-col"
    //                 >
    //                     {cityByParentId.map((city) => (
    //                         <Radio key={city.id} value={city.id}>
    //                             {city.locName}
    //                         </Radio>
    //                     ))}
    //                 </Radio.Group>
    //             </div>)
    //     }
    // ]
    const citiesCollapse = [
        {
            key: '22',
            label: `* شهر ${selectedCity !== 0 && cityByParentId.find(c => c.id === selectedCity)?.locName ?
                `/${cityByParentId.find(c => c.id === selectedCity)?.locName}` : ''}`,
            children: (
                <div className="flex flex-col space-y-4">
                    {/* Search Input */}
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        className="flex items-center bg-gray-100 p-2 rounded"
                    >
                        <input
                            type="text"
                            value={searchCity}
                            onChange={(e) => setSearchCity(e.target.value)}
                            placeholder="جست‌وجوی شهر"
                            className="w-full bg-transparent outline-none border-none"
                        />
                        <button type="submit">
                            <img src="/icons/search.svg" alt="جست و جو" />
                        </button>
                    </form>

                    {/* Filtered City List */}
                    <Radio.Group onChange={handleCityChange} className="flex flex-col">
                        {filteredCities.map((city) => (
                            <Radio key={city.id} value={city.id}>
                                {city.locName}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
            ),
        },
    ];



    const handleSelectDistrict = (selectedDistrictId) => {
        setSelectedAreaId(selectedDistrictId); // Set the selected district ID
    };
    const handleKeyPress2 = (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && collapseRef.current) {
            // Programmatically trigger a click on the Collapse header
            collapseRef.current.click();
            event.preventDefault();
        }
    }
    const handleCategoryChange = (value) => {
        if (isCategoryTradeTypeLocked) return;
        if (value === 2)
            setAdsMainCategoryCode(8)

        if (value === 3) {
            setAddedBy(1)
            setAdsMainCategoryCode(1)
        }

        setActiveKey([]);


        // یک برای کاربرسایت دو برای کرالر و سه برای ادمین
    }
    const handleOpenModal = () => {
        setIsModalVisible(true); // Show modal
    };

    const handleCloseModal = () => {
        setIsModalVisible(false); // Close modal
        setActiveKey(null);
    };
    const handleMapClick = (coords) => {
        console.log("handleMapClick: ", coords);
        setNoCoordinatesError(false)
        setSelectedCoordinates(coords);



        setFormErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.coordinates;
            return newErrors;
        });

    };
    const handleAdsTitleChange = (value) => {
        setAdsTitle(value)
        setNoTitleError(false)

        setFormErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            delete newErrors.adsTitle;
            return newErrors;
        });

        // OR USE destructuring

        // setFormErrors(prevErrors => {
        //     const { adsTitle, ...rest } = prevErrors;
        //     return rest;
        // });             
    }
    const handleMobilePhoneChange = (value) => {
        setNoPhonenumberError(false)
        const convertedValue = ConvertPersianToEnglish(value);
        const sanitizedValue = convertedValue.replace(/\D/g, ""); // Remove non-numeric characters
        if (sanitizedValue?.length > 11) {
            setLongPhonenumberError(true)
        } else {
            setLongPhonenumberError(false)
        }
        setNewPhoneNumber(sanitizedValue);
    }
    const handleAddPhoneNumber = () => {
        if (newPhoneNumber.trim() !== "") {
            setNoPhonenumberError(false)

            setFormErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors.phoneNumbers;
                return newErrors;
            });
            // Add the new phone number if valid
            setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
            setNewPhoneNumber(""); // Reset input
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleAddPhoneNumber();
        }
    }
    const handleEditPhoneNumber = (index, value) => {

        const updatedNumbers = [...phoneNumbers];

        updatedNumbers[index] = value;
        // Update the specific number
        setPhoneNumbers(updatedNumbers);
    };

    const handleRemovePhoneNumber = (index) => {
        const updatedNumbers = phoneNumbers.filter((_, i) => i !== index);
        setPhoneNumbers(updatedNumbers); // Remove the specific number
    };
    const handleSubmit = async () => {
        const newErrors = {};
        if (!phoneNumbers.length) {
            setNoPhonenumberError(true)
            console.log("Set Phone Error");

            newErrors.phoneNumbers = 'شماره تلفن الزامی است.'
        }
        // else if (!selectedAreaId) {
        //     setNoAreaError(true)
        // }
        if (adsTitle === "") {
            setNoTitleError(true)
            console.log("Set Title Error");
            newErrors.adsTitle = 'عنوان آگهی الزامی است.'
        }
        console.log("COORDINATES");
        console.log(selectedCoordinates);


        if (selectedCoordinates.length < 2) {
            setNoCoordinatesError(true)
            console.log("Set Coordinates Error");
            newErrors.coordinates = 'موقعیت آگهی الزامی است.'
        }
        if (!adsPrptyTradeTypeCode) {
            setNoPrptyTradeTypeCodeError(true)
        }
        if (!adsPrptyTypeCode) {
            setNoAdsPrptyTypeCodeError(true)
        }
        if (abilityToConvert && (!convertingDepositAmount || convertingDepositAmount === "" || !convertingRentAmount || convertingRentAmount === "")) {
            setAbilityToConvertError(true)
        }
        if ((adsPrptyCategoryCode === 8 || adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 4) && (!metrage || metrage === 0)) {
            setNoMetrageError(true)
        }
        if ((adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) && (!propertyLandMetarage || propertyLandMetarage === 0)) {
            setNoPropertyLandMetarageError(true)
        }


        setFormErrors(newErrors)

        console.log('ارورهای فرم:', formErrors);
        console.log('ارورها:', errors);
        console.log('ارورها keys:', Object.keys(errors));
        console.log('ارورها entries:', Object.entries(errors));
        console.log('ارورها values:', Object.values(errors));


        if (Object.keys(newErrors).length === 0) {

            console.log('details[0]', details[0]);



            await addOrder(
            /* id */ masterId,
            /* usruserCode */details[0].usruserCode,
            /* adsMainCategoryCode */ adsMainCategoryCode,
           /*  adsAdvertiseShowTypeCode */ 0,
           /* countryCode */1,
           /* "stateCode" */ selectedProvince,
          /*  "cityCode" */selectedCity,
          /*  "areaCode" */ selectedAreaId,
                selectedCoordinates ? selectedCoordinates[0] : null,
                selectedCoordinates ? selectedCoordinates[1] : null,
          /* selectedCoordinates[1] ?    selectedCoordinates[1]:0  */
                // selectedCoordinates[1]??null,
          /* isApproximateArea */isApproximateArea,
                adsTitle,

                phoneNumbers[0],
            /* landPhone */null,
            /* price */null,
            /* description */ description,
                null,
                null,
                null,
                fullName,
                address,
                isRenovated,
                balcony,
                officialDeed,
                buildingOrientation,
                floorMaterial,
                bathroomType,
                coolingSystem,
                heatingSystem,
                waterHeaterType,
                deed,
                parcelNumber,
                unitNumber
            )
        }


        // if (masterCode) {
        //     console.log("inside iffff");

        //     await addOrderDetails(
        //         0,  // id,
        //         masterCode,  // adsMasterCode,
        //         adsPrptyCategoryCode,  // adsPrptyCategoryCode,
        //         Number(adsPrptyTradeTypeCode), // adsPrptyTradeTypeCode,
        //         adsPrptyTypeCode,  // adsPrptyTypeCode,
        //         null, // adsAdvertiseTypeCode,
        //         Number(pricePerMeter), // pricePerMeter,
        //         Number(totalPrice), // totalPrice,
        //         propertyLandMetarage,  // propertyLandMetarage,
        //         propertyWidth, // propertyWidth,
        //         deposit, // deposit,
        //         rent, // rentPerMonth,
        //         abilityToConvert, // abilityToConvert,
        //         convertingDepositAmount, // convertingDepositAmount,
        //         convertingRentAmount,// convertingRentAmount,
        //         Number(metrage), // meterage,
        //         Number(numberOfRooms), // numberOfRooms,
        //         Number(lifeOfTheBuilding), // lifeOfTheBuilding,
        //         null, // dateForRent,
        //         Number(floorFrom),  // floorNumber,
        //         Number(floorTo), // totalFloor,
        //         Number(unitPerFloor), // unitPerFloor,
        //         parking, // parking,
        //         basement, // basement,
        //         elevator,  // elevator,
        //         description, // description, 26
        //     )
        // }


    }

    const onSubmitWithMasterCode = async () => {






        if (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) {
            addPropertyApplicantRentBuy(
                0,
                adsPrptyTradeTypeCode,
                masterCode,
                adsPrptyTypeCode,
                adsPrptyCategoryCode === 10 ? 10 : 11,
                buyPriceFrom,
                buyPriceTo,
                rentDepositFrom,
                rentDepositTo,
                rentPriceFrom,
                rentPriceTo,
                metrageFrom,
                meterageTo,
                lifeOfBuildingFrom,
                lifeOfBulidingTo,
                description


            )
        } else {
            console.log("Start Edit Details");
            const detailId = details.length > 0 ? details[0].id : 0
            await addOrderDetails(
                detailId,  // id,
                masterCode,  // adsMasterCode,
                adsPrptyCategoryCode,  // adsPrptyCategoryCode,
                Number(adsPrptyTradeTypeCode), // adsPrptyTradeTypeCode,
                adsPrptyTypeCode,  // adsPrptyTypeCode,
                null, // adsAdvertiseTypeCode,
                Number(pricePerMeter), // pricePerMeter,
                Number(totalPrice), // totalPrice,
                propertyLandMetarage,  // propertyLandMetarage,
                propertyWidth, // propertyWidth,
                deposit, // deposit,
                rent, // rentPerMonth,
                abilityToConvert, // abilityToConvert,
                convertingDepositAmount, // convertingDepositAmount,
                convertingRentAmount,// convertingRentAmount,
                Number(metrage), // meterage,
                Number(numberOfRooms), // numberOfRooms,
                Number(lifeOfTheBuilding), // lifeOfTheBuilding,
                null, // dateForRent,
                Number(floorFrom),  // floorNumber,
                Number(floorTo), // totalFloor,
                Number(unitPerFloor), // unitPerFloor,
                parking, // parking,
                basement, // basement,
                elevator,  // elevator,
                description, // description, 26
            )

        }

        await addPhoneNumbers(
            masterCode,
            phoneNumbers ?? [])

        imgList?.map((imageFile, index) => {
            saveOrderImg(
                masterCode,
                imageFile,
                index + 1,
            )

        })

        setSelectedAreaId(null)
        setAdsMainCategoryCode(null)
        setAdsPrptyTradeTypeCode(null)
        setAdsPrptyTypeCode(null)
        setAdsTitle("")
        setFullName("")
        setPhoneNumbers([])
        setAddress(null)
        setSelectedAreaName("")
        setSelectedCoordinates([])
        setSelectedCoordinates(null)
        setElevator(false)
        setBasement(false)
        setParking(false)
        setIsApproximateArea(false)
        setAddress("")
        setDescription("")
        setDeposit(null)
        setRent(null)
        setTotalPrice(null)
        setPricePerMeter(null)
        setPricePerMeter(null)
        setBuyPriceTo(null)
        setBuyPriceFrom(null)
        setUnitPerFloor(null)
        setFloorTo(null)
        setFloorFrom(null)
        setLifeOfTheBuilding(null)
        setPropertyWidth(null)
        setMetrage(null)
        setSquareFootageEntireProperty(null)
        setPropertyLandMetarage(null)
        setConvertingRentAmount(null)
        setConvertingDepositAmount(null)
        setDeposit(null)
        setRent(null)
        setNumberOfRooms(null)
        setLifeOfTheBuildingTo(null)
        setLifeOfTheBuildingFrom(null)
        setMeterageTo(null)
        setMetrageFrom(null)
        setRentPriceTo(null)
        setRentPriceFrom(null)
        setRentDepositTo(null)
        setRentDepositFrom(null)
        setImgList([])

        setImg9("/icons/Frame79.svg")
        setImg8("/icons/Frame79.svg")
        setImg7("/icons/Frame79.svg")
        setImg6("/icons/Frame79.svg")
        setImg5("/icons/Frame79.svg")
        setImg4("/icons/Frame79.svg")
        setImg3("/icons/Frame79.svg")
        setImg2("/icons/Frame79.svg")
        setImg1("/icons/Frame79.svg")

    }

    useEffect(() => {


        if (masterCode) {
            onSubmitWithMasterCode()
        }
    }, [masterCode])


    const districtsCollapse = [
        {
            key: '4',
            label: `محله /${selectedAreaName}`,
            children: (
                <div className='flex items-center justify-around w-full gap-4 '>
                    <div>
                        <form>
                            <div className='flex items-center bg-gray-100 p-2 rounded '>
                                <input
                                    onChange={async (e) => {
                                        setAreaList(areas.filter(area => area.locName.includes(e.target.value)));

                                    }}
                                    className='w-full bg-transparent outline-none border-none'
                                    type="text"
                                    placeholder="نام محله"
                                />
                                <button type='submit'>
                                    <img src="/icons/search.svg" alt="جست و جو" />
                                </button>
                            </div>
                        </form>
                        <div className="h-[300px] overflow-y-scroll overflow-x-hidden border-r border-l border-b rounded p-2 w-full z-50">
                            {areaList && areaList.map(area => (
                                <Radio
                                    key={area.id}
                                    value={area.id}
                                    checked={selectedAreaId === area.id} // Assuming selectedAreaId is a single selected district
                                    onChange={() => {
                                        handleSelectDistrict(area.id)
                                        setActiveKey([])
                                        setSelectedAreaName(area?.locName)
                                        // setNoAreaError(false)

                                    }} // handleSelectDistrict will set the selected district ID
                                    className="my-2 py-1 border-b hover:bg-gray-100 transition-all w-full"
                                >
                                    <p className="font-bold">{area.locName}</p>
                                    <p className="text-sm text-gray-800">{area.subAreas?.map((item, index) => index === area.subAreas?.length - 1 ? item : `${item}  ،`)}</p>

                                </Radio>
                            ))}
                        </div>
                    </div>
                </div>
            ),
        },
    ];
    const categoriesCollapse = [
        {
            key: '1',
            label: `* دسته بندی /${adsMainCategoryCode !== 8 ? `شخصی` : `تعاون`}  `,
            children:
                <Radio.Group
                    onChange={(e) => handleCategoryChange(e.target.value)}
                    value={adsMainCategoryCode === 8 ? 2 : 3}
                    className='flex flex-col rtyr'>
                    <Radio value={2} > تعاون</Radio >
                    <Radio value={3} >شخصی </Radio >
                </Radio.Group>
        },
    ];

    ;

    const openModal = [
        {
            key: '2',
            label: (
                <span onClick={() => handleOpenModal()}>انتخاب موقعیت مکانی از روی نقشه</span>
            ),

        },
    ];

    const adsPrptyTradeTypeCodeCollapse = [
        {
            key: '2',
            label: `* نوع معامله   ${adsPrptyTradeTypeCode ? `/` + adsPrptyTradeTypeCodes[adsPrptyTradeTypeCode] : ``} `,
            children:
                <Radio.Group
                    onChange={(e) => {
                        if (isCategoryTradeTypeLocked) return;
                        setAdsPrptyTradeTypeCode(e.target.value)
                        setActiveKey([])
                        setNoPrptyTradeTypeCodeError(false)
                    }

                    } value={adsPrptyTradeTypeCode}
                    className={`flex flex-col `}>
                    <Radio value={1} >فروش</Radio >
                    <Radio value={2} >رهن و اجاره</Radio >
                    <Radio value={3} >معاوضه</Radio >
                    <Radio value={4} >مشارکت در ساخت</Radio >
                    <Radio value={5} >پیش فروش</Radio >
                    <Radio value={6} >رهن و اجاره کوتاه مدت</Radio >
                    <Radio value={7} >متقاضی خرید</Radio >
                    <Radio value={8} >متقاضی اجاره</Radio >
                </Radio.Group>
        },
    ];
    const adsPrptyTypeCodeCollapse = [
        {
            key: '3',
            label: `* نوع ملک ${adsPrptyTypeCode ? `/` + propertyTypes[adsPrptyTypeCode] : ``}`,
            children:
                <Radio.Group
                    onChange={(e) => {
                        if (isCategoryTradeTypeLocked) return;

                        setNoAdsPrptyTypeCodeError(false)
                        setAdsPrptyTypeCode(e.target.value)
                        setActiveKey([])
                        setChooseLockedCategoryTradeTypeError(false)
                    }

                    } value={adsPrptyTypeCode} className='flex flex-col'
                >
                    <Radio value={1} >آپارتمان مسکونی</Radio >
                    <Radio value={2} >آپارتمان اداری</Radio >
                    <Radio value={3} >خانه و ویلا</Radio >
                    <Radio value={4} >زمین کلنگی</Radio >
                    <Radio value={5} >مستغلات</Radio >
                    <Radio value={6} >مغازه</Radio >
                    <Radio value={7} >صنعتی و کشاورزی</Radio >
                </Radio.Group >
        },

    ];


    const handleCollapseChange = (key) => {
        if (!isProvinceCityLocked) {
            // If clicking on the currently active one, close it
            if (activeKey === key) {
                setActiveKey(null);
            } else {
                setActiveKey(key);
            }
        }
    };
    const handleCollapseChange2 = (key) => {
        if (!isCategoryTradeTypeLocked) {
            // If clicking on the currently active one, close it
            if (activeKey === key) {
                setActiveKey(null);
            } else {
                setActiveKey(key);
            }
        }
    };







    return (
        <>
            {
                (!details.length || pageChangeLoader) ? (<Loader />) : (
                    <>
                        <div>
                            <div className='text-center text-2xl'> ویرایش آگهی</div>

                            <div className='flex text-gray-400'>
                                <div className='w-1/2'>
                                    وضعیت:  <span
                                        className={registerStatusArray.find(status => status.id === details[0]?.registerStatusCode)?.color}>
                                        {registerStatusArray.find(status => status.id === details[0]?.registerStatusCode)?.text}
                                        {details[0]?.registerStatusCode == 25 && (
                                            <em> ({rejectReason[details[0]?.rejectReasonCode]})</em>
                                        )}
                                    </span>
                                </div>
                                <div className='flex flex-col text-left w-1/2 gap-2'>
                                    <div>
                                        تاریخ ثبت: &nbsp;
                                        {details[0]?.adsDateTime != null ? moment.from(details[0]?.adsDateTime, 'en', 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss YYYY/MM/DD') : ''}
                                    </div>
                                    <div>
                                        تاریخ ویرایش: &nbsp;
                                        {details[0]?.updatedAt != null ? moment.from(details[0]?.updatedAt, 'en', 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss YYYY/MM/DD') : ''}
                                    </div>
                                    <div>
                                        <a
                                            className='cursor-pointer color-blue-600'
                                            href={`https://divar.ir/v/${details[0]?.divarToken}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            {`https://divar.ir/v/${details[0]?.divarToken}`}
                                        </a>
                                    </div>

                                    {details[0]?.mobilePhone && (
                                        <div>

                                            <a
                                                href={`https://wa.me/+98${details[0]?.mobilePhone.replace(/\D/g, '')}`}
                                                target='_blank'
                                                className='text-green-700 hover:underline'
                                                style={{ display: 'flex', alignItems: 'center', gap: '8px', direction: 'ltr' }}
                                            ><svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                style={{ verticalAlign: 'middle' }}
                                            >
                                                    <path
                                                        d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.36 5.06L2 22l4.94-1.36C8.42 21.5 10.15 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm3.88 15.82c-.33.92-.92 1.65-1.82 2.02-.9.37-1.85.47-2.8.28-1.88-.38-3.57-1.85-4.62-3.73-.73-1.33-.98-2.83-.73-4.33.23-1.37.82-2.6 1.72-3.52.45-.47 1-.78 1.6-.78.28 0 .55.05.82.15.27.1.52.25.73.45l.5.5c.25.25.47.53.62.85.15.33.23.68.23 1.05 0 .38-.08.75-.23 1.1l-.5.67c-.15.2-.28.42-.38.65-.1.23-.15.47-.13.72.05.73.37 1.43.88 2.05.52.62 1.17 1.08 1.88 1.38.25.1.5.15.77.13.25-.02.48-.12.68-.28l.67-.5c.35-.15.72-.23 1.1-.23.37 0 .73.08 1.05.23.32.15.6.37.85.62l.5.5c.2.2.35.45.45.72.1.27.15.55.15.83 0 .6-.3 1.15-.77 1.6z"
                                                        fill="#25D366"
                                                    />
                                                </svg>
                                                Whatsapp
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>


                            <div>
                                <span className='font-bold text-[16px]'>
                                    {picMaster.length}
                                    عکس
                                </span>

                                <Fancyboxx
                                    options={{
                                        Carousel: {
                                            infinite: false,
                                        },
                                    }}
                                >
                                    <div className={`flex flex-wrap gap-4 py-2 fiscal`}>
                                        {picMaster &&
                                            picMaster.map((item, index) => (
                                                item.picUrl.endsWith(".mp4") ||
                                                    item.picUrl.endsWith(".mov") ||
                                                    item.picUrl.endsWith(".MOV") ||
                                                    item.picUrl.endsWith(".3gp") ||
                                                    item.picUrl.endsWith(".ts") ||
                                                    item.picUrl.endsWith(".m3u8") ? (
                                                    <a
                                                        key={index}
                                                        data-fancybox="gallery"
                                                        href={`${baseURLWithoutAPI}/${item.picUrl}`}
                                                    >
                                                        <video
                                                            controls={true}
                                                            className="w-[98px] h-[72px] rounded"
                                                            src={`${baseURLWithoutAPI}/${item.picUrl}`}
                                                            alt={`Video ${index + 1}`}
                                                        />
                                                    </a>
                                                ) : (
                                                    <a
                                                        key={index}
                                                        data-fancybox="gallery"
                                                        href={`${baseURLWithoutAPI}${item.picUrl}`}
                                                    >
                                                        <div className="relative w-20 h-20">
                                                            {img1Binary ? (
                                                                <img
                                                                    className="absolute rounded w-[25px] top-0 bg-green-500 left-4 z-10"
                                                                    src="/icons/remove.svg"
                                                                    alt="remove"
                                                                />
                                                            ) : (
                                                                ""
                                                            )}
                                                            <img
                                                                className="absolute w-[98px] h-[72px] rounded"
                                                                src={`${baseURLWithoutAPI}${item.picUrl}`}
                                                                alt="انتخاب عکس"
                                                            />
                                                        </div>
                                                    </a>
                                                )
                                            ))}
                                    </div>
                                </Fancyboxx>
                            </div>

                            <div className='flex justify-between items-center my-3 gap-5'>
                                <div className='w-1/2'>
                                    <div className="flex items-center gap-1">
                                        <Checkbox
                                            checked={isProvinceCityLocked}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                if (selectedProvince !== 0 && selectedCity !== 0) {
                                                    setIsProvinceCityLocked(isChecked);
                                                }
                                                if (isChecked) {
                                                    if (selectedProvince !== 0 && selectedCity !== 0) {
                                                        const newLockedLocation = {
                                                            provinceId: selectedProvince,
                                                            cityId: selectedCity,
                                                        };
                                                        setLockedLocation(newLockedLocation);
                                                        localStorage.setItem('lockedLocation', JSON.stringify(newLockedLocation));
                                                        localStorage.setItem('isProvinceCityLocked', isChecked);
                                                    } else {
                                                        setChooseProvinceAndCityError(true)
                                                    }

                                                } else {
                                                    setIsProvinceCityLocked(false)
                                                    setLockedLocation({ provinceId: null, cityId: null });
                                                    localStorage.removeItem('lockedLocation');
                                                    localStorage.setItem('isProvinceCityLocked', false);
                                                }


                                            }}
                                        >
                                            قفل استان و شهر
                                        </Checkbox>
                                        {/* {lockedLocation} */}

                                    </div>
                                    {chooseProvinceAndCityError && <div className='text-red-800 text-[12px] '>ابتدا استان و شهر را انتخاب کنید</div>}
                                </div>
                                <div className='w-1/2'>
                                    <div className="flex items-center gap-1">
                                        <Checkbox
                                            checked={isCategoryTradeTypeLocked}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                if (adsMainCategoryCode && adsPrptyTradeTypeCode && adsPrptyTypeCode) {
                                                    setIsCategoryTradeTypeLocked(isChecked);

                                                    if (isChecked) {
                                                        const dataToLock = {
                                                            adsMainCategoryCode,
                                                            adsPrptyTradeTypeCode,
                                                            adsPrptyTypeCode,
                                                        };

                                                        setLockedCategoryTradeType(dataToLock);
                                                        localStorage.setItem('lockedCategoryTradeType', JSON.stringify(dataToLock));
                                                        localStorage.setItem('isCategoryTradeTypeLocked', true);
                                                    } else {
                                                        setLockedCategoryTradeType({
                                                            adsMainCategoryCode: null,
                                                            adsPrptyTradeTypeCode: null,
                                                            adsPrptyTypeCode: null,
                                                        });
                                                        localStorage.removeItem('lockedCategoryTradeType');
                                                        localStorage.setItem('isCategoryTradeTypeLocked', false);
                                                    }
                                                } else {
                                                    setChooseLockedCategoryTradeTypeError(true)
                                                }
                                            }}
                                        >
                                            دسته‌بندی و نوع معامله و نوع ملک
                                        </Checkbox>
                                    </div>
                                    {chooseLockedCategoryTradeTypeError && <div className='text-red-800 text-[12px] '>ابتدا دسته بندی، نوع معامله و نوع ملک را انتخاب کنید</div>}
                                </div>
                            </div>


                            <div className='flex justify-between items-center my-3 gap-5'>
                                <div className='w-1/2'>
                                    <div className='grid grid-cols-3 gap-1'>
                                        <div>
                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse

                                                activeKey={activeKey === '23' ? '23' : null}
                                                onChange={() => handleCollapseChange('23')}
                                                items={provincesCollapse}
                                                className={`collapse-ProductDetails ${isProvinceCityLocked ? 'opacity-50' : ''}`}
                                            />
                                        </div>
                                        <div>
                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse

                                                activeKey={activeKey === '22' ? '22' : null}
                                                onChange={() => handleCollapseChange('22')}
                                                items={citiesCollapse}
                                                className={`collapse-ProductDetails ${isProvinceCityLocked ? 'opacity-50' : ''}`}
                                            />
                                        </div>

                                        {/* <Collapse items={districtsCollapse} activeKey={activeKey} onChange={(key) => setActiveKey(key)} className='w-[350px] ml-1  absolute collapse-ProductDetails' /> */}
                                        <div
                                            tabIndex={0} // Make the wrapper focusable
                                            onFocus={(e) => {
                                                if (e.target.tagName !== 'INPUT') { // Prevent triggering if the focus is on the input
                                                    if (collapseRef.current) {
                                                        collapseRef.current.focus(); // Focus directly on the Collapse header

                                                    }
                                                }
                                            }}
                                            onKeyDown={handleKeyPress2} // Open Collapse on Enter/Space
                                            className={`relative w-full ml-1 collapse-wrapper focus:outline-2`}
                                        >

                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse
                                                activeKey={activeKey}
                                                onChange={(key) => setActiveKey(key)}
                                                className={`collapse-ProductDetails high-z-index absolute focus:outline-blue-500 focus:bg-blue-300`}
                                                items={districtsCollapse.map((item) => ({
                                                    ...item,
                                                    label: (
                                                        <span
                                                            tabIndex={-1} // Prevent label itself from being focusable
                                                            ref={collapseRef}
                                                            className=" "
                                                        >
                                                            {item.label}
                                                        </span>
                                                    ),
                                                }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='w-1/2'>
                                    <div className='grid grid-cols-3 gap-2'>
                                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse
                                                items={categoriesCollapse}
                                                activeKey={activeKey}
                                                onChange={() => handleCollapseChange2('1')}
                                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                                            />
                                        </div>
                                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse
                                                items={adsPrptyTradeTypeCodeCollapse}
                                                activeKey={activeKey}
                                                onChange={() => handleCollapseChange2('2')}
                                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                                            />
                                            {noPrptyTradeTypeCodeError && <p className='text-sm text-red-800'> نوع معامله نمیتواند خالی باشد</p>}
                                        </div>
                                        <div className="overflow-hidden whitespace-nowrap text-ellipsis">
                                            {/* <span className='text-red-700'>*</span> */}
                                            <Collapse
                                                items={adsPrptyTypeCodeCollapse}
                                                activeKey={activeKey}
                                                onChange={() => handleCollapseChange2('3')}
                                                className={`collapse-ProductDetails ${isCategoryTradeTypeLocked ? 'opacity-50' : ''}`}
                                            />
                                            {noAdsPrptyTypeCodeError && <p className='text-sm text-red-800'> نوع ملک نمیتواند خالی باشد</p>}

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div>
                                <div className='grid grid-cols-10 gap-2'>

                                    <div className='col-span-10                      '>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label htmlFor='adsTitle' className="flex-none">عنوان آگهی<span className='text-red-700'>*</span>:</label>
                                            <input
                                                onChange={(e) => handleAdsTitleChange(e.target.value)}
                                                value={adsTitle}
                                                className="flex-1 outline-none w-full text-black"
                                                name='adsTitle'
                                                id='adsTitle'
                                            />
                                        </div>
                                        {noTitleError && <p className='text-sm text-red-800'> عنوان آگهی نمیتواند خالی باشد</p>}
                                    </div>
                                </div>
                                <div className='grid grid-cols-3 gap-2 mt-2 mb-4'>

                                    <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]">
                                        <label htmlFor='ownerName' className="flex-none"> نام و نام خانوادگی:   </label>
                                        <input
                                            onChange={(e) => setFullName(e.target.value)}
                                            value={fullName}
                                            className="flex-1 outline-none w-full text-black"
                                            id='ownerName'
                                            name='ownerName'
                                        />
                                    </div>
                                    <div className=''>
                                        <div className={`${noPhonenumberError ? `border border-red-800` : `border border-[#D1D1D1]`} col-span-2 p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 rounded`}>
                                            <label className="flex-none">  شماره تماس<span className='text-red-700'>*</span>:</label>
                                            <input
                                                value={newPhoneNumber}
                                                onChange={(e) => handleMobilePhoneChange(e.target.value)}
                                                onKeyDown={handleKeyPress}
                                                className="flex-1 outline-none w-full text-black direction-ltr"

                                            />
                                            <img src='/icons/green-add.svg' alt='plus icon' className="flex-none cursor-pointer" onClick={handleAddPhoneNumber} />
                                        </div>
                                        {noPhonenumberError && <p className='text-sm text-red-800'>شماره تماس نمیتواند خالی باشد</p>}
                                        {longPhonenumberError && <p className='text-sm text-red-800'>شماره تماس نمیتواند بیشتر از 12 رقم باشد</p>}
                                        {/* Display list of phone numbers */}
                                        <ul className="space-y-2 ">
                                            {phoneNumbers.map((number, index) => (
                                                <li
                                                    key={index}
                                                    className="flex items-center gap-2 border border-[#D1D1D1] p-1 px-2 rounded-small text-base rounded my-1"
                                                    onClick={() => setEditIndex(index)}
                                                >
                                                    {/* Conditional rendering for edit mode */}

                                                    <input
                                                        value={number}
                                                        onChange={(e) => handleEditPhoneNumber(index, e.target.value)}
                                                        className="flex-1 outline-none text-black"
                                                    />
                                                    {/* Delete Button */}
                                                    <button
                                                        className="text-red-500"
                                                        onClick={() => handleRemovePhoneNumber(index)}
                                                    >
                                                        <img src='/icons/minus.svg' alt='minus' />
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    <div>
                                        {phoneNumbers?.length ?
                                            (
                                                <div className='flex flex-1 flex-wrap space-y-1'>
                                                    {isRealEstateAgent && <div className="bg-red-500 text-white w-full justify-center items-center rounded flex">مشاور است</div>}
                                                    {responseFromAdsMasterByPhoneNumber
                                                        ?.filter(item => item?.id != masterId)
                                                        .map((item) => {
                                                            const maxLength = 24; // Define the maximum length for the title
                                                            const truncatedTitle =
                                                                item?.adsTitle?.length > maxLength
                                                                    ? item.adsTitle.substring(0, maxLength) + "..."
                                                                    : item.adsTitle;
                                                            return (


                                                                <div
                                                                    key={item.id}
                                                                    className="border border-[#D1D1D1]  w-1/2 2xl:w-full p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded">

                                                                    <a
                                                                        href={`/updateAd?id=${item.id}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className='w-full flex items-center justify-between' >
                                                                        {item?.registerStatusCode === 25 && (<span className='text-red-500 text-3xl'>&#x2022;</span>)}
                                                                        {item?.registerStatusCode === 23 && (<span className='text-green-500 text-3xl'>&#x2022;</span>)}
                                                                        {item?.registerStatusCode === 24 && (<span className='text-amber-500 text-3xl'>&#x2022;</span>)}
                                                                        {/* {item?.adsTitle} */}

                                                                        <Tooltip title={item?.adsTitle}>
                                                                            {truncatedTitle}
                                                                        </Tooltip>
                                                                        <img src='/icons/arrow-left.svg' alt='arrow' />
                                                                    </a>
                                                                </div>


                                                            )
                                                        }
                                                        )}
                                                </div>
                                            )
                                            :
                                            <></>


                                        }
                                    </div>
                                </div>

                                {
                                    (adsPrptyCategoryCode !== 7 && adsPrptyCategoryCode !== 8) &&
                                    <div className='flex justify-between gap-2'>
                                        <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-1 max-h-[34px]">
                                            <label className="flex-none">آدرس<span className='text-red-700'>*</span>:</label>
                                            <input
                                                onChange={(e) => setAddress(e.target.value)}
                                                value={address}
                                                className="flex-1 outline-none w-full text-black"

                                            />
                                        </div>
                                        <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-2 max-h-[34px]  ">
                                            <label className="flex-none">    پلاک</label>
                                            <input
                                                onChange={(e) => setParcelNumber(e.target.value)}
                                                value={parcelNumber}
                                                className="flex-1 outline-none w-full text-black"

                                            />
                                        </div>

                                        <div className="border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474] flex flex-wrap gap-2 rounded flex-2 max-h-[34px]  ">
                                            <label className="flex-none">    واحد</label>
                                            <input
                                                onChange={(e) => setUnitNumber(e.target.value)}
                                                value={unitNumber}
                                                className="flex-1 outline-none w-full text-black"

                                            />
                                        </div>

                                    </div>
                                }










                                {/* <p>{adsPrptyCategoryCode}</p> */}

                                <div className='grid grid-cols-12 gap-2 my-2'>
                                    {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6) &&
                                        <div className='grid grid-cols-8 gap-2 col-span-8'>
                                            <div className='col-span-4'>
                                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]">
                                                    <label className="flex-none">قیمت متری</label>
                                                    <input
                                                        value={FormatPrice(pricePerMeter)}
                                                        onChange={(e) => {
                                                            let rawValue = convertPersianToEnglish(e.target.value);
                                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                                            setPricePerMeter(rawValue.replace(/,/g, "")); // Save raw number without commas
                                                        }}
                                                        className="flex-1 outline-none w-full text-black direction-ltr"
                                                    />
                                                    <span class="text-gray-500 border-r pr-2">تومان</span>
                                                </div>
                                                {pricePerMeter ? (
                                                    <p className="px-3 text-[12px] text-green-600">
                                                        {Num2persian(pricePerMeter)} تومان
                                                    </p>
                                                ) : null}
                                            </div>

                                            <div className='col-span-4'>
                                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]">
                                                    <label className="flex-none">قیمت کل</label>
                                                    <input
                                                        value={FormatPrice(totalPrice)}
                                                        onChange={(e) => {
                                                            let rawValue = convertPersianToEnglish(e.target.value);
                                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                                            setTotalPrice(rawValue.replace(/,/g, "")); // Save raw number without commas
                                                        }}
                                                        className="flex-1 outline-none w-full text-black direction-ltr"
                                                    />
                                                    <span class="text-gray-500 border-r pr-2">تومان</span>
                                                </div>
                                                {totalPrice ? (
                                                    <p className="px-3 text-[12px] text-green-600">
                                                        {Num2persian(totalPrice)} تومان
                                                    </p>
                                                ) : null}
                                            </div>
                                        </div>
                                    }



                                    {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) &&

                                        <>
                                            <div className='col-span-4'>
                                                <div className="  border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                    <label className="flex-none"> ودیعه</label>
                                                    <input

                                                        value={FormatPrice(deposit)} // Format the displayed value
                                                        // onChange={(e) => {
                                                        //     const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                        //     setDeposit(rawValue); // Set the raw numeric value in Formik state
                                                        // }}
                                                        onChange={(e) => {
                                                            let rawValue = convertPersianToEnglish(e.target.value);
                                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                                            setDeposit(rawValue.replace(/,/g, "")); // Save raw number without commas
                                                        }}
                                                        className="flex-1 outline-none w-full text-black direction-ltr"
                                                    />
                                                    <span class="text-gray-500 border-r pr-2">تومان</span>

                                                </div>
                                                {deposit ? (
                                                    <p className="px-3 text-[12px] text-green-600">
                                                        {Num2persian(deposit)} تومان
                                                    </p>
                                                ) : null}
                                            </div>

                                            <div className='col-span-4'>
                                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                    <label className="flex-none">  اجاره</label>
                                                    <input

                                                        value={FormatPrice(rent)} // Format the displayed value
                                                        onChange={(e) => {
                                                            // const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                            // setRent(rawValue); // Set the raw numeric value in Formik state

                                                            let rawValue = convertPersianToEnglish(e.target.value);
                                                            rawValue = rawValue.replace(/[^0-9,]/g, ""); // Allow commas
                                                            setRent(rawValue.replace(/,/g, "")); // Save raw number without commas
                                                        }}
                                                        className="flex-1 outline-none w-full text-black direction-ltr"
                                                    />
                                                    <span class="text-gray-500 border-r pr-2">تومان</span>

                                                </div>
                                                {rent ? (
                                                    <p className="px-3 text-[12px] text-green-600">
                                                        {Num2persian(rent)} تومان
                                                    </p>
                                                ) : null}
                                            </div>










                                        </>}






                                    {(adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 3 || adsPrptyCategoryCode === 4) &&
                                        <div className=' col-span-4 grid gap-2 gap-y-2 grid-cols-3 xl:col-span-9'>
                                            {/* 
                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full  xl: " >
                                <label className="flex-none">  متراژ</label>
                                <input

                                    value={metrage} // Format the displayed value
                                    onChange={(e) => {
                                        setMetrage(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black direction-ltr"
                                />
                                {noMetrageError && <p className='text-sm text-red-800'> متراژ  نمیتواند خالی باشد</p>}

                            </div>

                            <div className="border border-[#D1D1D1] p-1  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                                <label className="flex-none">  تعداد اتاق</label>
                                <input

                                    value={numberOfRooms} // Format the displayed value
                                    onChange={(e) => {
                                        setNumberOfRooms(e.target.value)
                                    }}
                                    className="flex-1 outline-none w-full text-black"
                                />

                            </div>
                             */}
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                                                <label className="flex-none">  عمر بنا  </label>
                                                <input

                                                    value={lifeOfTheBuilding} // Format the displayed value
                                                    onChange={(e) => {
                                                        setLifeOfTheBuilding(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>

                                            {(adsPrptyCategoryCode !== 8 && adsPrptyCategoryCode !== 10 && adsPrptyCategoryCode !== 11) && (
                                                <div>
                                                    <Col>
                                                        <Checkbox name='isRenovated' checked={isRenovated} className=" font-bold" onClick={() => setIsRenovated(!isRenovated)} value="5"> بازسازی شده</Checkbox>
                                                    </Col>
                                                </div>
                                            )}

                                        </div>}

                                </div>


                                {(adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 4 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12)
                                    &&
                                    <div className='grid grid-cols-9'>

                                        <Col className='text-xl font-bold flex items-center  pb-6  col-span-1'>
                                            <Checkbox checked={abilityToConvert} onChange={() => setAbilityToConvert(!abilityToConvert)} >قابلیت تبدیل</Checkbox>
                                        </Col>

                                        {abilityToConvert &&

                                            <div className='col-span-8 grid gap-2 grid-cols-8 '>

                                                <div className='col-span-4'>
                                                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px]" >
                                                        <label className="flex-none"> تبدیل مبلغ  ودیعه</label>
                                                        <input

                                                            value={FormatPrice(convertingDepositAmount)} // Format the displayed value
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                                setConvertingDepositAmount(rawValue); // Set the raw numeric value in Formik state
                                                            }}
                                                            className="flex-1 outline-none w-full text-black"
                                                        />

                                                    </div>
                                                    {convertingDepositAmount ? (
                                                        <p className="px-3 text-[12px] text-green-600">
                                                            {Num2persian(convertingDepositAmount)} تومان
                                                        </p>
                                                    ) : null}
                                                </div>

                                                <div className='col-span-4'>
                                                    <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] " >
                                                        <label className="flex-none">  تبدیل مبلغ   اجاره</label>
                                                        <input

                                                            value={FormatPrice(convertingRentAmount)} // Format the displayed value
                                                            onChange={(e) => {
                                                                const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                                                                setConvertingRentAmount(rawValue); // Set the raw numeric value in Formik state
                                                            }}
                                                            className="flex-1 outline-none w-full text-black"
                                                        />

                                                    </div>
                                                    {convertingRentAmount ? (
                                                        <p className="px-3 text-[12px] text-green-600">
                                                            {Num2persian(convertingRentAmount)} تومان
                                                        </p>
                                                    ) : null}
                                                </div>
                                                {abilityToConvertError && <p className='text-sm text-red-800 col-span-8'>   در صورت فعال بودن قابلیت تبدیل این مقادیر نمیتوانند خالی باشند </p>}                            </div>
                                        }


                                    </div>
                                }










                                <div className='grid grid-cols-4 gap-2 my-2'>
                                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                                        <div>
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  متراژ زمین<span className='text-red-700'>*</span> </label>
                                                <input

                                                    value={propertyLandMetarage} // Format the displayed value
                                                    onChange={(e) => {
                                                        setPropertyLandMetarage(e.target.value)
                                                        setNoPropertyLandMetarageError(false)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                            {noPropertyLandMetarageError && <p className='text-sm text-red-800'> متراژ زمین  نمیتواند خالی باشد</p>}
                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  متراژ زیر بنای کل</label>
                                            <input

                                                value={squareFootageEntireProperty} // Format the displayed value
                                                onChange={(e) => {
                                                    setSquareFootageEntireProperty(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                    </>}
                                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 8 || adsPrptyCategoryCode === 12) && <>
                                        {adsPrptyCategoryCode === 8 &&
                                            <>
                                                <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                    <label className="flex-none">  متراژ</label>
                                                    <input

                                                        value={metrage} // Format the displayed value
                                                        onChange={(e) => {
                                                            setMetrage(e.target.value)
                                                            setNoMetrageError(false)

                                                        }}
                                                        className="flex-1 outline-none w-full text-black"
                                                    />

                                                </div>
                                            </>
                                        }

                                        {(adsPrptyCategoryCode === 12 || adsPrptyCategoryCode === 8) &&
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none"> عرض ملک</label>
                                                <input

                                                    value={propertyWidth} // Format the displayed value
                                                    onChange={(e) => {
                                                        setPropertyWidth(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                        }

                                    </>}
                                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7 || adsPrptyCategoryCode === 12) && <>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none"> عمر بنا  </label>
                                            <input

                                                value={lifeOfTheBuilding} // Format the displayed value
                                                onChange={(e) => {
                                                    setLifeOfTheBuilding(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>

                                    </>}

                                </div>

                                <div className='grid grid-cols-5 gap-2'>
                                    {
                                        (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2) &&
                                        <div className='col-span-4 grid grid-cols-4 gap-2 xl:mb-2'>

                                            {/* copy from price row */}
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full  xl: " >
                                                <label className="flex-none">  متراژ<span className='text-red-700'>*</span>:</label>
                                                <input

                                                    value={metrage} // Format the displayed value
                                                    onChange={(e) => {
                                                        setMetrage(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black direction-ltr"
                                                />
                                                {noMetrageError && <p className='text-sm text-red-800'> متراژ  نمیتواند خالی باشد</p>}

                                            </div>

                                            <div className="border border-[#D1D1D1] p-1  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full xl:" >
                                                <label className="flex-none">  تعداد اتاق</label>
                                                <input

                                                    value={numberOfRooms} // Format the displayed value
                                                    onChange={(e) => {
                                                        setNumberOfRooms(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>

                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  طبقه چندم از   </label>
                                                <input

                                                    value={floorFrom} // Format the displayed value
                                                    onChange={(e) => {
                                                        setFloorFrom(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>

                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  تعداد کل طبقات </label>
                                                <input

                                                    value={floorTo} // Format the displayed value
                                                    onChange={(e) => {
                                                        setFloorTo(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                        </div>
                                    }

                                    {(adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                                        <>


                                            <div className="border border-[#D1D1D1] p-1 px-2  rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  تعداد طبقات ساختمان</label>
                                                <input

                                                    value={floorTo} // Format the displayed value
                                                    onChange={(e) => {
                                                        setFloorTo(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>

                                        </>}
                                    {
                                        (adsPrptyCategoryCode === 1 || adsPrptyCategoryCode === 2 || adsPrptyCategoryCode === 6 || adsPrptyCategoryCode === 7) &&
                                        <div className='col-span-1 '>
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  واحد در طبقه   </label>
                                                <input

                                                    value={unitPerFloor} // Format the displayed value
                                                    onChange={(e) => {
                                                        setUnitPerFloor(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                        </div>
                                    }
                                </div>



                                {
                                    (adsPrptyCategoryCode === 10) &&
                                    <div className='grid grid-cols-2 gap-2 my-2'>
                                        <div>
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  قیمت از  </label>
                                                <input

                                                    value={buyPriceFrom} // Format the displayed value
                                                    onChange={(e) => {
                                                        setBuyPriceFrom(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                            {buyPriceFrom ? (
                                                <p className="px-3 text-[12px] text-green-600">
                                                    {Num2persian(buyPriceFrom)} تومان
                                                </p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                                <label className="flex-none">  قیمت تا  </label>
                                                <input

                                                    value={buyPriceTo} // Format the displayed value
                                                    onChange={(e) => {
                                                        setBuyPriceTo(e.target.value)
                                                    }}
                                                    className="flex-1 outline-none w-full text-black"
                                                />

                                            </div>
                                            {buyPriceTo ? (
                                                <p className="px-3 text-[12px] text-green-600">
                                                    {Num2persian(buyPriceTo)} تومان
                                                </p>
                                            ) : null}
                                        </div>
                                    </div>
                                }
                                {
                                    (adsPrptyCategoryCode === 11) &&
                                    <div className='grid grid-cols-4 my-2 gap-2'>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  ودیعه از  </label>
                                            <input

                                                value={rentDepositFrom} // Format the displayed value
                                                onChange={(e) => {
                                                    setRentDepositFrom(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  ودیعه تا  </label>
                                            <input

                                                value={rentDepositTo} // Format the displayed value
                                                onChange={(e) => {
                                                    setRentDepositTo(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>


                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  اجاره از  </label>
                                            <input

                                                value={rentPriceFrom} // Format the displayed value
                                                onChange={(e) => {
                                                    setRentPriceFrom(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  اجاره تا  </label>
                                            <input

                                                value={rentPriceTo} // Format the displayed value
                                                onChange={(e) => {
                                                    setRentPriceTo(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                    </div>
                                }
                                {
                                    (adsPrptyCategoryCode === 10 || adsPrptyCategoryCode === 11) &&
                                    <div className='grid grid-cols-4 gap-2'>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  متراژ از  </label>
                                            <input

                                                value={metrageFrom} // Format the displayed value
                                                onChange={(e) => {
                                                    setMetrageFrom(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">  متراژ تا  </label>
                                            <input

                                                value={meterageTo} // Format the displayed value
                                                onChange={(e) => {
                                                    setMeterageTo(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none"> عمر بنا از</label>
                                            <input

                                                value={lifeOfBuildingFrom} // Format the displayed value
                                                onChange={(e) => {
                                                    setLifeOfTheBuildingFrom(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>
                                        <div className="border border-[#D1D1D1] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2  rounded max-h-[34px] w-full " >
                                            <label className="flex-none">   تا  </label>
                                            <input

                                                value={lifeOfBulidingTo} // Format the displayed value
                                                onChange={(e) => {
                                                    setLifeOfTheBuildingTo(e.target.value)
                                                }}
                                                className="flex-1 outline-none w-full text-black"
                                            />

                                        </div>



                                    </div>
                                }



                                <div className="flex w-1/6 justify-between border border-[#D1D1D1]  p-1 px-2 rounded-small text-base font-medium text-[#747474]  items-center flex-wrap gap-2 max-h-[34px] rounded my-4" onClick={() => setIsAdsDetailVisible(true)}>
                                    جزئیات آگهی
                                    <img src='/icons/arrow-back-simple.svg' alt='' />
                                </div>

                                <Row className=' w-full col-span-6'>
                                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                                        <Checkbox checked={parking} onClick={() => setParking(!parking)} name='parking' value="1">پارکینگ</Checkbox>
                                    </Col>
                                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                                        <Checkbox checked={basement} onClick={() => setBasement(!basement)} name='basement' value="2">انباری</Checkbox>
                                    </Col>
                                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                                        <Checkbox checked={elevator} onClick={() => setElevator(!elevator)} name='elevator' value="3">آسانسور</Checkbox>
                                    </Col>
                                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center'>
                                        <Checkbox checked={balcony} onClick={() => setBalcony(!balcony)} name='balcony' value="4">بالکن</Checkbox>
                                    </Col>
                                    {(adsPrptyCategoryCode === 5 || adsPrptyCategoryCode === 12 || adsPrptyTypeCode != 1) &&
                                        <>
                                            <Col className='tracking-wide text-xl font-bold flex items-center justify-center ml-1'>
                                                <Checkbox checked={officialDeed} onClick={() => setOfficialDeed(!officialDeed)} value="3">سند اداری </Checkbox>
                                            </Col>
                                        </>
                                    }
                                    <Col className='tracking-wide text-xl font-bold flex items-center justify-center mr-auto'>
                                        <Checkbox checked={isApproximateArea} onClick={() => setIsApproximateArea(!isApproximateArea)} name='isApproximateArea' className='whitespace-nowrap'>نمایش محدوده آگهی</Checkbox>
                                    </Col>

                                </Row>
                                <div className='grid grid-cols-2 gap-2 lg:flex lg:flex-col '>
                                    <div className='mt-2 h-full'>
                                        <label>توضیحات</label>
                                        <textarea
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows={8}
                                            className='w-full border border-[#D1D1D1] outline  outline-[#D1D1D1] rounded h-[400px]' />
                                    </div>
                                    <MapWithSingleMarker
                                        position={

                                            selectedCoordinates
                                        }
                                        routing="false"
                                        zoom="13"
                                        onMapClick={handleMapClick}
                                        selectedAreaId={selectedAreaId}
                                        selectedProvinceId={selectedProvinceId}
                                        selectedCityId={selectedCityId}
                                        isInCreateAdPage={true}
                                        centerLatitude={areaCenterLatitude}
                                        centerLongitude={areaCenterLongitude}
                                    />
                                </div>




                                {Object.keys(formErrors).length > 0 && (
                                    <div>
                                        <ul className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                                            {Object.entries(formErrors).map(([key, message]) => (
                                                <li key={key}>{message}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}





                                <div className='w-full py-3 sticky text-center bottom-0 bg-white'>
                                    <button type='submit' onClick={handleSubmit} className='rounded py-1 px-12 bg-green-900 text-white w-max'>
                                        به روز رسانی آگهی
                                    </button>
                                    <button className='border border-[1px]-black px-5 rounded-md min-w-[173px] mx-1 shadow-[0px_0px_2px_1px_#0000001A]' onClick={inCompleteHandler}>ثبت ناقصی</button>
                                    <button
                                        className='text-[#D70000] border border-[1px]-black px-5 py-1 rounded-md min-w-[173px] mx-1 shadow-[0px_0px_2px_1px_#0000001A] transition-all hover:text-white hover:bg-[#D70000]'
                                        onClick={rejectFileHandler}>
                                        رد کردن
                                    </button>


                                    <div className='flex mt-5 justify-center min-w-[200px] gap-12'>
                                        <div className='flex cursor-pointer'
                                            onClick={() => {
                                                if (nextId) {
                                                    // handleNextPrev(nextId, true)
                                                    navigate(`/updateAd?id=${nextId}`)
                                                } else {
                                                    callGetDetailMasterByQuery(true)
                                                }
                                            }}>
                                            <img src='/icons/arrow-forward-simple.svg' />
                                            {nextId}
                                            <p className='text-[#747474] text-[16px]'

                                            >{nextId ? "قبلی" : "صفحه قبل"} </p>
                                        </div>

                                        <div className='flex cursor-pointer'
                                            onClick={() => {


                                                if (prevId) {
                                                    // handleNextPrev(prevId, false)
                                                    navigate(`/updateAd?id=${prevId}`)
                                                } else {
                                                    callGetDetailMasterByQuery(false)
                                                }
                                                // if (nextId) window.location.href = `/productDetails/${nextId}`;
                                            }}>
                                            <p className='text-[#747474] text-[16px]'>
                                                {prevId ? "بعدی" : "صفحه بعد"}
                                            </p>
                                            {prevId}
                                            <img src='/icons/arrow-forward-simple.svg' className='rotate-180' />
                                        </div>
                                    </div>
                                </div>

                            </div >
                        </div >
                    </>
                )
            }
            <Modal title="جزئیات بیشتر " open={isAdsDetailVisible} onCancel={() => setIsAdsDetailVisible(false)} footer={false}>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded mt-4 mb-2">
                    <label className="flex-none"> جهت ساختمان:  </label>
                    <input
                        onChange={(e) => setBuildingOrientation(e.target.value)}
                        value={buildingOrientation}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> جنس کف:  </label>
                    <input
                        onChange={(e) => setFloorMaterial(e.target.value)}
                        value={floorMaterial}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none">سرویس بهداشتی:  </label>
                    <input
                        onChange={(e) => setBathroomType(e.target.value)}
                        value={bathroomType}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> سرمایش:  </label>
                    <input
                        onChange={(e) => setCoolingSystem(e.target.value)}
                        value={coolingSystem}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> گرمایش:  </label>
                    <input
                        onChange={(e) => setHeatingSystem(e.target.value)}
                        value={heatingSystem}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none">تأمین‌کننده آب گرم:   </label>
                    <input
                        onChange={(e) => setWaterHeaterType(e.target.value)}
                        value={waterHeaterType}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
                <div className="border border-[#D1D1D1] min-w-[348px] p-1 px-2 rounded-small text-base font-medium text-[#747474] flex items-center flex-wrap gap-2 max-h-[34px] rounded my-2">
                    <label className="flex-none"> سند:  </label>
                    <input
                        onChange={(e) => setDeed(e.target.value)}
                        value={deed}
                        className="flex-1 outline-none w-full text-black"

                    />
                </div>
            </Modal>

            <Modal title="  توضیحات   " open={isRejectionModalVisible} onCancel={() => setIsRejectionModalVisible(false)} footer={false}>
                <div className="w-full grid grid-cols-1 gap-4 mt-6">
                    {adsRejectReason?.map((ad) => (
                        <label key={ad?.id} htmlFor={`${ad.id}`} className='' >
                            <input
                                className='cursor-pointer'
                                type='radio'
                                id={ad?.id}
                                name='rejectionReason'
                                value={ad.id}
                                onChange={() => {
                                    setSelectedRejectionReason(ad?.id)
                                    if (ad?.id === 1048) {
                                        setIsTextAreaVisible(true)
                                    } else {
                                        setIsTextAreaVisible(false)
                                    }
                                }} />
                            {/* <label htmlFor={`reject-${ad.id}`} className="cursor-pointer"> */}
                            {ad.description}
                            {/* </label> */}

                            {/* {ad?.description} */}
                        </label>

                    ))}

                    {isTextAreaVisible ? <textarea placeholder='سایر دلایل را ذکر کنید' className='p-1' onChange={(e) => setOtherReasonsText(e?.target?.value)}> </textarea> : <></>}
                    <button
                        disabled={selectedRejectionReason === 0}
                        onClick={() => sendRejection()}
                        className={`${selectedRejectionReason ? `bg-red-600` : `bg-red-300 cursor-not-allowed`} px-6 py-1  text-white rounded`}>
                        رد کردن
                    </button>
                </div>
            </Modal>
        </>
    )
}
